import React, { useEffect, useState, useCallback } from 'react';
import {} from '@alifd/next';
import {
  Card,
  Cascader,
  Space,
  Form,
  Upload,
  Button,
  message,
  Input,
  Checkbox,
} from 'antd';
import client from '@/lib/feathers';
import moment from 'moment';
import axios from 'axios';
import styles from './index.module.scss';
import useService from '@/lib/hooks/useService';
import { generateHouseHoldNumberCascader } from './generateHouseHoldNumberCascader';
// import { handleSubmit } from '@/pages/GroupBuyingOrderManagement/components/AddOrder/helper';

const ResidentEmitAdd = () => {
  const [form] = Form.useForm();
  const residentAccountNumbers = client.service('residentAccountNumbers');
  const [receiveNowValue, setReceiveNowValue] = useState('');
  // const [contentText, setContentText] = useState('');
  const [residentAccountNumbersArr, setResidentAccountNumbersArr] = useState(
    []
  );
  const [allAllows, setAllAllows] = useState(false);
  const [isHouseholdSelect, setIsHouseholdSelect] = useState(false);
  const [files, setFiles] = useState(null);

  const [hasMembersResidents] = useService({
    collectionName: 'residentAccountNumbers',
    query: {
      $and: [
        { $expr: { $gt: [{ $size: '$members' }, 0] } },
        { members: { $exists: true } },
      ],
    },
  });
  // console.log(hasMembersResidents);

  const [noMembersResidents] = useService({
    collectionName: 'residentAccountNumbers',
    query: {
      $or: [
        { $expr: { $eq: [{ $size: '$members' }, 0] } },
        { members: { $exists: false } },
      ],
    },
  });

  const noMembersHouseholdNumbers = noMembersResidents.map(
    (residentObj) => residentObj.householdNumber
  );

  const householdNumbers = residentAccountNumbersArr.map(
    (residentObj) => residentObj.householdNumber
  );
  const generatedHouseholdNumbers = generateHouseHoldNumberCascader(
    householdNumbers,
    noMembersHouseholdNumbers
  );

  const funFindResident = useCallback(
    async (para) => {
      const result = await residentAccountNumbers.find({ query: para });
      return result && result.data ? result.data : [];
    },
    [residentAccountNumbers]
  );

  function householdNumberSort(a, b) {
    return a.building > b.building
      ? 1
      : -1 && parseInt(a.floor) > parseInt(b.floor)
      ? 1
      : -1 && parseInt(a.floorChild) > parseInt(b.floorChild)
      ? 1
      : -1;
  }

  const serverResidentDataUpdate = useCallback(() => {
    funFindResident({}).then((result) => {
      setResidentAccountNumbersArr(result.sort(householdNumberSort));
    });
  }, [funFindResident]);

  useEffect(() => {
    serverResidentDataUpdate();
  }, [serverResidentDataUpdate]);

  const handleCascaderOnChange = (values) => {
    setReceiveNowValue(values);
    updateIsHouseholdSelect(values);
    setAllAllows(false);
  };

  const updateIsHouseholdSelect = (receivedValue) => {
    if (receivedValue.length > 0) {
      setIsHouseholdSelect(true);
    } else {
      setIsHouseholdSelect(false);
    }
  };

  // const getReceiveNowValue = () =>
  //   receiveNowValue.map((valueArr) => {
  //     return valueArr.length > 1 ? [valueArr.join('-')] : valueArr;
  //   });

  const uploadFiles = (dbName, file) => {
    const formData = new FormData();
    formData.append('files', file);
    console.log(file);
    const res = axios.post(
      `/newUploads?type=${dbName}&isConvertPng=true`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          authorization: localStorage.getItem('feathers-jwt'),
        },
      }
    );
    return res;
  };
  // 圖片刪除
  const deleteFile = (file) => {
    return client.service('uploads').remove(file.response._id);
  };

  const onFinish = async (value) => {
    console.log(value);
    const houseHoldNumber = value?.receiveNowValue
      ? value.receiveNowValue.map((valueArr) => {
          return valueArr.length > 1 ? [valueArr.join('-')] : valueArr;
        })
      : null;

    const hasMembersHouseholdNumbers = await hasMembersResidents.map(
      (residentObj) => residentObj.householdNumber
    );
    console.log(files);
    console.log(houseHoldNumber);
    console.log(hasMembersHouseholdNumbers);
    console.log();
    axios('/ezcon/api/emitMsgQuery', {
      method: 'POST',
      headers: { authorization: window.localStorage['feathers-jwt'] },
      data: {
        service: 'message',
        serviceId: '650a9996d53c9aa4290068da',
        event: 'msg',
        title: '個人通知',
        content: `${value.contentText}-${moment().format('YYYY/MM/DD HH:mm')}`,
        type: 'success',
        class: 'message',
        duration: 8000,
        files,
        redirect: '/ezpro/personalNotice',
        query: {
          householdNumbers: {
            $in:
              value.allAllows === true
                ? hasMembersHouseholdNumbers
                : houseHoldNumber,
          },
          firebaseClass: '社區管理',
        },
      },
    })
      .then((res) => {
        console.log('==send message Success:', res);
        setReceiveNowValue('');
        // setContentText('');
        setAllAllows(false);
        setIsHouseholdSelect(false);
        message.success('已傳送推播給住戶');
        form.resetFields();
      })
      .catch((error) => {
        console.error('==send message fail:', error);
        message.error('傳送推播失敗');
      });
  };

  return (
    <Card>
      <Space direction="vertical" className={styles.container}>
        <Form onFinish={onFinish} form={form} layout="vertical">
          <Form.Item label="戶號" name="receiveNowValue">
            <Cascader
              multiple
              className={styles.householdCascader}
              allowClear
              placeholder="請選擇戶號"
              options={generatedHouseholdNumbers}
              onChange={handleCascaderOnChange}
              showCheckedStrategy="SHOW_CHILD"
              maxTagCount="responsive"
              size="large"
              disabled={allAllows}
              displayRender={(label) => label.join('-')}
            />
          </Form.Item>
          <Form.Item name="allAllows" valuePropName="checked">
            <Checkbox
              name="allAllow"
              checked={allAllows}
              disabled={isHouseholdSelect}
              onChange={(checked) => {
                console.log(checked);
                setAllAllows(checked);
                setReceiveNowValue('');
              }}
            >
              全戶推播
            </Checkbox>
          </Form.Item>
          <Form.Item
            label="訊息內容"
            name="contentText"
            rules={[{ required: true, message: '請輸入訊息內容!' }]}
          >
            <Input.TextArea
              className={styles.input}
              name="content"
              placeholder="請輸入內容"
              maxLength={500}
              rows={6}
              hasLimitHint
              aria-label="input max length 500"
            />
          </Form.Item>
          <Form.Item
            name="files"
            valuePropName="fileList"
            label="檔案上傳"
            getValueFromEvent={(e) => {
              const { fileList } = e;
              setFiles(fileList);
              return fileList;
            }}
            rules={[
              {
                validator: (_, value) => {
                  if (value) {
                    if (
                      value.map((item) => item.status).includes('uploading')
                    ) {
                      return Promise.reject(new Error('上傳中'));
                    }
                    if (value.map((item) => item.status).includes('error')) {
                      return Promise.reject(
                        new Error('上傳失敗，請重新上傳或者移除檔案')
                      );
                    }
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Upload
              fileList={form.getFieldValue('files')}
              accept=".doc,.docx,.pdf"
              customRequest={async (options) => {
                const { onSuccess, file } = options;
                if (file.size > 1024 * 1024 * 20) {
                  message.error('上傳檔案不能超過20MB');
                  return;
                }
                try {
                  const res = await uploadFiles('personalNotice', options.file);
                  console.log(res);
                  onSuccess(res.data.length > 0 ? res.data[0] : res.data);
                } catch (err) {
                  console.log(err);
                }
              }}
              onRemove={async (file) => {
                try {
                  await deleteFile(file);
                } catch (err) {
                  console.error({ err });
                }
              }}
            >
              <Button>上傳</Button>
            </Upload>
          </Form.Item>
        </Form>
        <Button
          type="primary"
          className={styles.emit}
          onClick={() => {
            form.submit();
          }}
        >
          通知住戶
        </Button>
      </Space>
    </Card>
  );
};

export default ResidentEmitAdd;
